var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaypayPorque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 392.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .7;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-7, .cls-8, .cls-12, .cls-14 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-8, .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e0e0e0;\n      }\n\n      .cls-3 {\n        fill: #f5f5f5;\n      }\n\n      .cls-4 {\n        fill: #ebebeb;\n      }\n\n      .cls-5 {\n        fill: #e6e6e6;\n      }\n\n      .cls-6, .cls-14 {\n        fill: #263238;\n      }\n\n      .cls-7 {\n        fill: #000;\n        opacity: .2;\n      }\n\n      .cls-8 {\n        opacity: .8;\n      }\n\n      .cls-9, .cls-12 {\n        fill: #2895c9;\n      }\n\n      .cls-10 {\n        fill: #ff8b7b;\n      }\n\n      .cls-11 {\n        fill: #ff5652;\n      }\n\n      .cls-12, .cls-14 {\n        opacity: .3;\n      }\n\n      .cls-15 {\n        fill: #f0f0f0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-136"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 347.4,
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 435,
    y: 363.49,
    width: 14.9,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 322.53,
    y: 366.21,
    width: 8.69,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 396.59,
    y: 354.21,
    width: 34.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 66.44,
    y: 359.37,
    width: 43.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 118.53,
    y: 359.37,
    width: 15.58,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 161.08,
    y: 356.01,
    width: 93.68,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M237,302.8H43.91c-3.15,0-5.7-2.56-5.7-5.71V25.66c.03-3.13,2.57-5.65,5.7-5.66h193.09c3.15,0,5.71,2.56,5.71,5.71h0v271.38c0,3.15-2.56,5.71-5.71,5.71ZM43.91,20.2c-3.01,0-5.45,2.45-5.45,5.46v271.43c0,3.01,2.44,5.45,5.45,5.46h193.09c3.01,0,5.45-2.45,5.46-5.46V25.66c0-3.01-2.45-5.45-5.46-5.46H43.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M453.31,302.8h-193.1c-3.15,0-5.7-2.56-5.71-5.71V25.66c.03-3.13,2.58-5.65,5.71-5.66h193.1c3.13.01,5.66,2.53,5.69,5.66v271.43c0,3.15-2.54,5.7-5.69,5.71ZM260.21,20.2c-3.01,0-5.45,2.45-5.46,5.46v271.43c0,3.01,2.45,5.45,5.46,5.46h193.1c3.01,0,5.45-2.45,5.46-5.46V25.66c0-3.01-2.45-5.45-5.46-5.46h-193.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.57,
    y: 81,
    width: 94.67,
    height: 266.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 169.23,
    y: 81,
    width: 251.01,
    height: 266.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.57,
    y: 114.33,
    width: 114.67,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 179.23,
    y: 114.33,
    width: 251.01,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.57,
    y: 154.33,
    width: 114.67,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 179.23,
    y: 154.33,
    width: 251.01,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.57,
    y: 194.33,
    width: 114.67,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 179.23,
    y: 194.33,
    width: 251.01,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.57,
    y: 234.33,
    width: 114.67,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 179.23,
    y: 234.33,
    width: 251.01,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.57,
    y: 274.33,
    width: 114.67,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 179.23,
    y: 274.33,
    width: 251.01,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.57,
    y: 314.33,
    width: 114.67,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 179.23,
    y: 314.33,
    width: 251.01,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.13,
    width: 144,
    height: 71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 167.01,
    y: 71,
    width: 12.22,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 101.13,
    y: 63.28,
    width: 144,
    height: 7.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 101.13,
    width: 144,
    height: 7.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 304.74,
    y: 29.6,
    width: 71.39,
    height: 45.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 336.55,
    y: 74.65,
    width: 7.76,
    height: 6.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 304.74,
    y: 69.76,
    width: 71.39,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 304.74,
    y: 29.6,
    width: 71.39,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 356.63,
    y: 89.08,
    width: 25.25,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 381.87,
    y: 89.09,
    width: 24.42,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 326.63,
    y: 89.08,
    width: 25.25,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 351.87,
    y: 89.09,
    width: 24.42,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 296.63,
    y: 89.08,
    width: 25.25,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 321.87,
    y: 89.09,
    width: 24.42,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 266.63,
    y: 89.08,
    width: 25.25,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 291.87,
    y: 89.09,
    width: 24.42,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 92.51,
    y: 127.78,
    width: 10.58,
    height: 26.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 82.29,
    y: 127.77,
    width: 10.23,
    height: 26.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 105.08,
    y: 127.78,
    width: 10.58,
    height: 26.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 94.85,
    y: 127.77,
    width: 10.23,
    height: 26.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 117.64,
    y: 127.78,
    width: 10.58,
    height: 26.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 107.42,
    y: 127.77,
    width: 10.23,
    height: 26.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 130.22,
    y: 127.78,
    width: 10.58,
    height: 26.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 119.99,
    y: 127.77,
    width: 10.23,
    height: 26.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 101.17,
    y: 256.45,
    width: 14.24,
    height: 17.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 87.4,
    y: 256.44,
    width: 13.77,
    height: 17.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 118.09,
    y: 256.45,
    width: 14.24,
    height: 17.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 104.32,
    y: 256.44,
    width: 13.77,
    height: 17.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 135.01,
    y: 256.45,
    width: 14.24,
    height: 17.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 121.24,
    y: 256.44,
    width: 13.77,
    height: 17.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 151.92,
    y: 256.45,
    width: 14.24,
    height: 17.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 138.16,
    y: 256.44,
    width: 13.77,
    height: 17.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 372.6,
    y: 169.08,
    width: 13.99,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 386.6,
    y: 169.09,
    width: 13.53,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 355.97,
    y: 169.08,
    width: 13.99,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 369.96,
    y: 169.09,
    width: 13.53,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339.34,
    y: 169.08,
    width: 13.99,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 353.34,
    y: 169.09,
    width: 13.53,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 322.72,
    y: 169.08,
    width: 13.99,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 336.72,
    y: 169.09,
    width: 13.53,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 286.34,
    y: 169.08,
    width: 13.99,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 300.34,
    y: 169.09,
    width: 13.53,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 269.71,
    y: 169.08,
    width: 13.99,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 283.71,
    y: 169.09,
    width: 13.53,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.09,
    y: 169.08,
    width: 13.99,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 267.08,
    y: 169.09,
    width: 13.53,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.46,
    y: 169.08,
    width: 13.99,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 250.46,
    y: 169.09,
    width: 13.53,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 329.69,
    y: 256.45,
    width: 34.1,
    height: 17.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 363.79,
    y: 256.44,
    width: 32.97,
    height: 17.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 289.17,
    y: 256.45,
    width: 34.1,
    height: 17.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 323.28,
    y: 256.44,
    width: 32.97,
    height: 17.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.66,
    y: 256.45,
    width: 34.1,
    height: 17.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 282.76,
    y: 256.44,
    width: 32.97,
    height: 17.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.15,
    y: 256.45,
    width: 34.1,
    height: 17.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 242.25,
    y: 256.44,
    width: 32.97,
    height: 17.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 208.71,
    cy: 143.08,
    r: 11.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 238.71,
    cy: 143.08,
    r: 11.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 268.71,
    cy: 143.08,
    r: 11.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 298.71,
    cy: 143.08,
    r: 11.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 88.18,
    cy: 226.93,
    r: 7.42,
    transform: "translate(-49.77 26.32) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 107.96,
    cy: 226.92,
    r: 7.42,
    transform: "translate(-49.24 30.87) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 127.75,
    cy: 226.92,
    r: 7.42,
    transform: "translate(-130.78 258.11) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 147.53,
    cy: 226.92,
    r: 7.42,
    transform: "translate(-117.25 170.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 332.88,
    cy: 306.64,
    r: 7.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 352.36,
    cy: 305.43,
    r: 7.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 373.98,
    cy: 306.63,
    r: 7.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 394.54,
    cy: 306.63,
    r: 7.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 343.46,
    cy: 295.87,
    r: 7.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 364.01,
    cy: 295.87,
    r: 7.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 383.39,
    cy: 294.7,
    r: 7.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 233.11,
    cy: 306.63,
    r: 7.71,
    transform: "translate(-148.55 254.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 253.65,
    cy: 306.63,
    r: 7.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 274.19,
    cy: 306.65,
    r: 7.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 294.75,
    cy: 306.62,
    r: 7.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 243.68,
    cy: 295.87,
    r: 7.71,
    transform: "translate(-122.92 407.77) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 264.23,
    cy: 295.87,
    r: 7.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 284.77,
    cy: 295.87,
    r: 7.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "376.96 214.2 382.61 234.33 353.01 234.33 376.96 214.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "376.96 214.2 366.67 234.33 397.9 234.33 376.96 214.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "330.15 214.2 335.8 234.33 306.19 234.33 330.15 214.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "330.15 214.2 319.86 234.33 351.09 234.33 330.15 214.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "283.33 214.2 288.99 234.33 259.38 234.33 283.33 214.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "283.33 214.2 273.04 234.33 304.28 234.33 283.33 214.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "90.7 174.78 87.55 194.33 104.06 194.33 90.7 174.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "90.7 174.78 96.44 194.33 79.02 194.33 90.7 174.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "116.81 174.78 113.66 194.33 130.17 194.33 116.81 174.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "116.81 174.78 122.55 194.33 105.13 194.33 116.81 174.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "142.92 174.78 139.76 194.33 156.28 194.33 142.92 174.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "142.92 174.78 148.66 194.33 131.24 194.33 142.92 174.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "236.52 214.2 242.17 234.33 212.57 234.33 236.52 214.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "236.52 214.2 226.23 234.33 257.47 234.33 236.52 214.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-136"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-136",
    className: "cls-3",
    cx: 250,
    cy: 381.24,
    rx: 193.89,
    ry: 11.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cash-register--inject-136"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 171.34,
    y: 205.62,
    width: 146.1,
    height: 175.62,
    rx: 8.65,
    ry: 8.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 211.24,
    y: 205.62,
    width: 106.2,
    height: 175.62,
    rx: 8.65,
    ry: 8.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 221.18,
    y: 226.38,
    width: 86.31,
    height: 32.73,
    rx: 2.47,
    ry: 2.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 218.41,
    y: 75.56,
    width: 17.6,
    height: 130.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "236.01 145.2 218.41 145.2 218.41 179.19 236.01 177.02 236.01 145.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "236.01 76.45 218.41 76.45 218.41 86.34 236.01 84.17 236.01 76.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.25,169.39l-4.91-71.25c-.17-2.42,1.66-4.51,4.08-4.68.1,0,.2-.01.3-.01h109.41c2.31,0,4.22,1.78,4.38,4.08l4.9,71.25c.17,2.41-1.65,4.51-4.06,4.68-.11,0-.21.01-.32.01h-109.41c-2.3,0-4.22-1.78-4.37-4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M288.87,96.7h-106.71c-1.37,0-2.48,1.11-2.48,2.48,0,.06,0,.11,0,.17l4.72,68.56c.09,1.3,1.17,2.31,2.47,2.31h106.71c1.37,0,2.48-1.1,2.49-2.47,0-.06,0-.12,0-.18l-4.72-68.57c-.09-1.3-1.18-2.3-2.48-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M288.87,96.7h-106.71c-1.37,0-2.48,1.11-2.48,2.48,0,.06,0,.11,0,.17l4.72,68.56c.09,1.3,1.17,2.31,2.47,2.31h106.71c1.37,0,2.48-1.1,2.49-2.47,0-.06,0-.12,0-.18l-4.72-68.57c-.09-1.3-1.18-2.3-2.48-2.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 196.29,
    y: 203.24,
    width: 93.66,
    height: 2.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "263.88 162.19 193.4 162.19 189.49 105.43 259.97 105.43 263.88 162.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "284.03 110.51 265.04 110.51 264.69 105.43 283.68 105.43 284.03 110.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "285.43 130.98 266.44 130.98 265.45 116.5 284.44 116.5 285.43 130.98"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 208.98,
    y: 55.11,
    width: 35.41,
    height: 26.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 208.98,
    y: 55.11,
    width: 14.73,
    height: 26.43
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M320.8,168.81l1.95-2.49c.74-.94,1.88-1.46,3.07-1.4l5.56.25c2.22.11,4.25,1.28,5.46,3.15l.74,1.16c-3,4.35-9.37,6.87-9.37,6.87l-1.74.92c-1.47.83-3.34.32-4.17-1.16,0-.01-.01-.02-.02-.03l-1.87-3.44c-.64-1.24-.49-2.74.39-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M340.15,118.94c.58.71,1,1.21,1.42,1.81s.84,1.15,1.25,1.72c.82,1.16,1.57,2.34,2.32,3.52,1.46,2.39,2.79,4.85,4,7.38.62,1.26,1.18,2.56,1.75,3.86s1.05,2.63,1.51,4c.96,2.72,1.73,5.5,2.32,8.33l.11.46c.07.33.1.66.1,1,0,1.79-.34,3.56-1,5.22-.56,1.38-1.28,2.68-2.15,3.89-1.47,1.98-3.22,3.75-5.18,5.24-1.76,1.35-3.62,2.55-5.58,3.58-1.93,1.02-3.93,1.89-6,2.59-1.97.67-4.11-.37-4.79-2.34-.47-1.37-.11-2.89.92-3.91l.25-.24c1.23-1.23,2.65-2.56,3.88-3.86,1.22-1.25,2.37-2.57,3.44-3.95.93-1.15,1.72-2.41,2.35-3.75.5-1.12.44-2,.29-2l.21,1.42c-.75-2.16-1.55-4.3-2.52-6.43s-2-4.22-3.16-6.3-2.35-4.12-3.64-6.12c-.64-1-1.3-2-2-3l-1-1.44-.92-1.3-.24-.34c-2.34-3.42-1.46-8.09,1.96-10.42,3.19-2.18,7.5-1.58,9.98,1.37h.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.43,110.46c-2.82,6.4-2.64,14.39,6,26.61,5.74.63,16.36-6.83,16.36-6.83,0,0-7.29-20.45-22.36-19.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M321.62,88.21c-1.67,6.2-3.73,17.56.29,21.69,0,0-5.87-.88-18.33,6.83-3.61-5.18-.93-6.83-.93-6.83,7-1.65,7.24-6.77,6.39-11.59l12.58-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M296.26,114.51c1.85-4,6.21-7.81,9.22-7.24s4.84,1.51,6.62,0,6.18-3.71,8.42-1.22c3.15,3.48,7.92,1,6.12,4.81-1.94,4.14-30.38,3.65-30.38,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.09,76.83c-.12.85-.66,1.51-1.2,1.47s-.88-.76-.76-1.61.66-1.5,1.2-1.46.89.77.76,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.56,75.29l-1.9-.73s.79,1.66,1.9.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M298.91,78.43c-1.02,1.88-2.28,3.63-3.74,5.19.95,1.12,2.88.78,2.88.78l.86-5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.68,70.09c-.06-.11-.09-.24-.06-.36.09-.26.36-.4.62-.33,1.59.36,2.92,1.44,3.6,2.92.09.22-.01.48-.24.58-.02.01-.05.02-.07.02-.26.08-.54-.06-.65-.31-.56-1.16-1.62-2.01-2.88-2.28-.13-.04-.25-.12-.32-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M326.92,75.77c-1.89,10-2.47,14.27-8.18,19.07-8.59,7.23-20.4,3.41-21.52-6.8-1-9.18,2.23-24,12.54-27.31,6.74-2.47,14.21.99,16.68,7.73.86,2.34,1.02,4.87.48,7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M304.5,79c-3.62-5.67-7.54-12.75-5.08-17.67s8.05-3.75,8.05-3.75c0,0,10.83-6.08,20.53,1.84,12.86,10.53-.93,22.12-4.34,32.16-3.77,11.05-23.21-2.33-19.16-12.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.92,60.62c-5.23-19.45-28.17-10.51-34.84,1l2.72.71c27.37-17.66,13.89,7.87,14.12,18.28s10.55,16.82,10.55,16.82c0,0,12.67-17.37,7.45-36.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353,95c-2.92,0-7-.55-9.66-3.24-2.4-2.43-3.15-6.14-2.21-11,.3-1.54.78-3.35,1.28-5.26,1.58-6,3.55-13.38.45-16-2.18-1.85-6.77-1.2-13.65,1.91-.12.06-.26.01-.32-.1,0,0,0-.01,0-.02-.06-.13,0-.27.13-.33h0c7.16-3.25,11.8-3.85,14.17-1.84,3.34,2.82,1.42,10.09-.28,16.51-.51,1.9-1,3.7-1.28,5.23-.9,4.72-.2,8.28,2.08,10.59,4.25,4.3,12.69,2.84,12.78,2.82.14-.02.27.07.29.21.02.14-.07.27-.21.29-1.18.17-2.37.25-3.56.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M328.39,57.34c.25-1.27-2.95-.74-3.1.39s-.57.5-1.82,2.15-1.42,3.59,2.68,4.87c2.6.81,3-1.19,4.33-2.19.73-.54,1.55-.82,2.08-1.23.36-.28.43-.8.14-1.16-.14-.18-.34-.29-.56-.32-1.68-.14-4.01-1.26-3.75-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M306.34,82.56c-.91,1.75-2.51,3.04-4.42,3.54-2.35.52-3.24-2.19-2.35-4.83.8-2.36,3-5.49,5.24-4.81s2.8,3.81,1.53,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.13,386.17c7.77-1.16,7.92-2.45,12.09-3.91,3.57-1.26,4.57-1.08,7.45-2.05,2.41-.81,1.59-3.1,0-5.54-.79-1.22-.91-2.38-1.78-4.55l-11.81,1.75c-1.14,3.3-1.55,7.52-8.29,9.93-4.01,1.44-.79,4.83,2.34,4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M277.11,386.2c7.73,0,9.21-.51,13.56-.66,3.72-.13,4.33.66,8.1.66,2.5,0,2.85-2.82,1.93-4.93-.71-1.64-.82-3.61-1.34-5.74h-10.65c-1.92,3.37-7.16,5.87-13,6.29-4.2.31-1.71,4.38,1.4,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.14,175.63s-1.54,55.58,1.76,90.88c-.21,33.13.81,109,.81,109,.26,1.69,9.14,1,10.65,0,0,0,16.65-55.27,9.26-109,18.49-56.06,14.5-90.88,14.5-90.88h-36.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.23,175.63s18.06,62.73,25.38,93.54c7.7,32.35,30.58,81.26,32.48,102.7,2,.79,8.39-.09,11.81-1.75,0,0-3.13-68.37-21.73-99.52,4.2-76.64-16.6-95-16.6-95l-31.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M353.55,367.58c.18,1.47.26,2.95.23,4.43-.04.51.35.96.86,1,.02,0,.05,0,.07,0,4.42,0,10.53-1.88,12.46-2.54.37-.12.62-.46.62-.85v-4.19c0-.51-.42-.93-.94-.92-.05,0-.1,0-.14.01l-12.44,2.09c-.45.09-.76.51-.72.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M287.49,370.86c0,1.15-.1,3.2-.21,4.71,0,.5.36.93.85,1,3.91.32,7.85.28,11.75-.13.38-.03.7-.32.77-.7l.8-4.13c.07-.55-.31-1.05-.86-1.12-.02,0-.03,0-.05,0l-12.14-.48c-.47-.03-.88.33-.91.81,0,.02,0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.74,125.68c-.24,6.47-.14,12.95.28,19.41.33,8.43.91,16.72,2.12,30.54h42.43c-.85-11.95.54-25.57,8.16-52.46,1.67-5.21-1.2-10.78-6.41-12.45-.67-.21-1.35-.36-2.05-.42-1.68-.17-3.47-.31-5.3-.4-6.41-.46-12.85-.46-19.26,0-2.1.19-4.27.46-6.34.75-7.55,1.12-13.25,7.41-13.63,15.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M328.36,170.38c-8.49,2.17-21.41,2.79-42.62.53.51,11.25-4.44,86.9-4.44,86.9,0,0,43,9.45,67.31-3.38,1.57-57.17-20.25-84.05-20.25-84.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M312.13,216s11.67-10.87,17.43-18.29c-.46,7.78-7.41,14.76-17.43,18.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M247.75,125.62l2.82,1.43c1.07.53,1.82,1.56,2,2.74l.83,5.5c.35,2.21-.4,4.44-2,6l-1,1c-4.84-2.06-8.56-7.85-8.56-7.85l-1.24-1.53c-1.11-1.28-.97-3.21.31-4.32.01-.01.03-.02.04-.03l3-2.5c1.07-.88,2.56-1.05,3.8-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M298.4,126.62c-.31.86-.54,1.46-.81,2.15s-.56,1.31-.84,2c-.56,1.3-1.18,2.55-1.81,3.8-1.27,2.5-2.68,4.93-4.22,7.28-.76,1.18-1.57,2.34-2.39,3.49s-1.7,2.27-2.63,3.36c-1.83,2.23-3.8,4.34-5.92,6.3l-.28.27c-.25.24-.53.46-.83.64-1.22.76-2.58,1.28-4,1.54-1.18.22-2.39.26-3.58.14-1.82-.22-3.59-.71-5.26-1.46-2.6-1.2-5.03-2.73-7.23-4.55-2-1.64-3.9-3.41-5.66-5.3-1.74-1.85-3.37-3.81-4.87-5.86-1.22-1.68-.86-4.03.82-5.25,1.26-.92,2.97-.97,4.28-.11l.17.11c1.86,1.21,3.83,2.53,5.75,3.71s3.86,2.33,5.76,3.3c1.7.92,3.5,1.65,5.36,2.17.54.17,1.11.22,1.67.16.13,0,.12-.1,0-.1-.24,0-.47.07-.68.18l-1.1.92c1.46-1.76,2.88-3.56,4.19-5.49s2.58-3.91,3.75-6,2.31-4.15,3.36-6.29c.53-1.06,1-2.14,1.53-3.21l.71-1.6.64-1.45.17-.38c1.68-3.78,6.12-5.49,9.9-3.8,3.57,1.59,5.32,5.65,4.03,9.33h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.54,110.49c-6.93.9-13.67,5.2-19.64,18.94,2.44,5.24,14.32,10.47,14.32,10.47,0,0,13.7-16.9,5.32-29.41Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaypayPorque);
export default __webpack_public_path__ + "static/media/waypay-porque.dc162375379011e309260d2518e367b7.svg";
export { ForwardRef as ReactComponent };